import { Stack, Typography, BoxProps, Box, Card } from "@mui/material";
import { ScoresVariationsPopover } from "./ScoresVariationsPopover";
import { Score } from "src/types";
import { Heading } from "src/api/sure-api/ssq/useGetOneSsq";
import { ScoresChart } from "src/components/Chart/ScoresChart";
import { getFormattedScoreByScoreId } from "src/utils/ssq";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { getScoresByIds } from "src/utils/scores";
import { useScoreContext } from "src/context/ScoreContext";
import { useTheme } from "@mui/material";

/**
 * @remarks
 * Legacy ScoresChart wrapper that uses `formattedScores`, from `2025-01-15` this usage is deprecated.
 * in order to display the precise data.
 *
 * @see ScoreChart located @ `src/components/ScoreChart`
 * @refactor This component will be removed since ScoreChart is agnostic and no wrapper are needed
 */
type ScoresVariationsSectionProps = BoxProps & {
    headings?: Heading[];
    scoresIds: number[];
};
export const ScoresVariationsSection = (props: ScoresVariationsSectionProps) => {
    const theme = useTheme();
    const { scoresIds, headings = [] } = props;
    const { scores = [] } = useFoodpilotContext();
    const { displayedScoreId, displayedVariationId = 0, formattedScores } = useScoreContext();

    const scoresToDisplay = getScoresByIds(scoresIds, scores);
    const initialScore = scoresToDisplay[0];

    const initialScoreTitle = initialScore?.title;
    const initialScoreLabel = initialScore?.label ?? initialScoreTitle;

    const formattedScore = getFormattedScoreByScoreId(formattedScores, displayedScoreId);
    const chaptersScore = formattedScore?.chaptersScore;
    const scoreVariations = formattedScore?.scoreVariations;

    const selectedScore = (scores ?? []).find((score: Score) => score.id === chaptersScore?.score_id) ?? initialScore;
    const selectedScoreTitle = selectedScore?.title ?? initialScoreLabel;
    const selectedScoreLabel = selectedScore?.label ?? selectedScoreTitle;

    const displayedVariation = scoreVariations?.[displayedVariationId];
    const scoreVariation = displayedVariation ?? scoreVariations?.[0];

    const displayedVariationLabel = displayedVariationId ? scoreVariation?.label : selectedScoreLabel;

    return (
        <Card
            elevation={0}
            sx={{
                border: "1px solid #E7E6E4",
                borderRadius: theme.shape.borderRadius,
            }}
        >
            <Box
                sx={{
                    mb: theme.spacing(2),
                    backgroundColor: "#FEFCFB",
                    borderBottom: "1px solid #E7E6E4",
                    p: theme.spacing(2, 3),
                }}
            >
                <Stack direction="row" alignItems="center">
                    <Stack flex={1} gap="4px">
                        <Typography variant="h3">{selectedScoreTitle}</Typography>
                        <Typography variant="body">
                            {displayedVariation ? displayedVariationLabel : selectedScoreLabel}
                        </Typography>
                    </Stack>
                    <ScoresVariationsPopover scores={scoresToDisplay} />
                </Stack>
            </Box>
            <Box
                sx={{
                    mb: theme.spacing(2),
                    p: theme.spacing(2, 3),
                }}
            >
                <ScoresChart
                    formattedScores={formattedScores}
                    headings={headings}
                    displayedScoreId={displayedScoreId}
                    displayedVariationId={displayedVariation ? displayedVariationId : 0}
                    precision={selectedScore?.precision}
                />
            </Box>
        </Card>
    );
};
